<template>
    <div class="field col-12 grid">
        <label for="category" class="col-12 mb-2 md:col-6 md:mb-0 font-bold"
            >{{ label }}<span :class="'ml-3 status-badge status-' + operationalLearningValue">{{ getSendOptionName(operationalLearningValue) }}</span></label
        >
        <div class="col-12 md:col-6">
            <div class="flex">
                <div class="col-7">
                    <base-dropdown v-model="operationalLearningValue" optionLabel="name" optionValue="id" :options="sendOptions" :showClear="false" />
                </div>
                <div class="col-5">
                    <Button label="Confirm" @click="confirmChange({ learningId: learningId, operationType: OLtype, sendOption: operationalLearningValue }, updateOperationalLearning)" />
                </div>
            </div>
        </div>
    </div>
    <Divider />
</template>

<script setup>
import BaseDropdown from '../../../../../modules/custom-inputs/BaseDropdown.vue';
import { useConfirmRemove } from '../../../../../composables/ConfirmComposable';
import { ref, onMounted, defineProps } from 'vue';
import { getSendTypes } from '../constants/index';
import { learningOutcomeStore } from '../../../../../store/global-stores';
const props = defineProps({
    operationalLearning: {
        type: Number,
    },
    label: {
        type: String,
    },
    learningId: {
        type: Number,
    },
    OLtype: {
        type: String,
    },
});

const operationalLearningValue = ref(null);
const { confirmChange } = useConfirmRemove();
onMounted(() => {
    setOperationalLearningValue();
});

const setOperationalLearningValue = () => {
    operationalLearningValue.value = props.operationalLearning;
};

const sendOptions = getSendTypes();
const getSendOptionName = (outcomeVal) => {
    return sendOptions.find((opt) => opt.id === outcomeVal)?.name;
};

const updateOperationalLearning = async (data) => {
    await learningOutcomeStore.sendToRolNolJol(data);
};
</script>
<style scoped>
.status-badge {
    border-radius: var(--border-radius);
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;

    &.status-1 {
        background: red;
        color: white;
        /**background: #ffcdd2;
        color: #c63737;**/
    }
    &.status-2 {
        background: #feedaf;
        color: #8a5340;
    }
    &.status-3 {
        background: green;
        color: white;
        /**background: #c8e6c9;
        color: #256029;**/
    }
}
</style>
